import useFaqPdfLink from 'hooks/useFaqPdfLink';
import {
  bindHover,
  bindMenu,
  usePopupState,
} from 'material-ui-popup-state/hooks';
import { useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'redux/store';
import { downloadFaq } from 'services/api/download';

import { AccountCircle, KeyboardArrowDown } from '@mui/icons-material';

import BackdropLoading from 'components/BackdropLoading';
import PasswordRecoverModal from 'components/PasswordRecoverModal/PasswordRecoverModal';

import { persistor, store } from '../../../redux/store';
import {
  ButtonDropdown,
  DropdownItem,
  DropdownItemLink,
  DropdownMenu,
} from '../Navbar.styles';

const UserMenu = () => {
  const profileMenuState = usePopupState({ variant: 'popover' });
  const { usuario } = useSelector((state: RootState) => state.token);
  const [recoverPasswordModalOpen, setRecoverPasswordModalOpen] =
    useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const faqPdfLink = useFaqPdfLink();

  const userName = useMemo(() => {
    if (usuario) {
      if (usuario?.nome.length < 16) {
        return usuario.nome;
      }

      if (usuario?.nome.includes(' ')) {
        const firstname = usuario.nome.split(' ')[0];

        if (firstname.length < 16) return firstname;
        return firstname.substring(0, 15) + '...';
      }
      return usuario.nome.substring(0, 15) + '...';
    }
  }, [usuario]);

  const handleLogout = () => {
    setIsLoading(true);
    window.location.href = `${process.env.REACT_APP_GESTAO_BASE_URL}/logon?logout=true`;
    setTimeout(() => {
      localStorage.clear();
      store.dispatch({ type: 'RESET' });
      persistor.purge();
    }, 150);
  };

  const handleRecoverPasswordModal = () => {
    setRecoverPasswordModalOpen(!recoverPasswordModalOpen);
  };

  return (
    <>
      {isLoading && <BackdropLoading />}
      <ButtonDropdown
        {...bindHover(profileMenuState)}
        startIcon={<AccountCircle />}
        endIcon={<KeyboardArrowDown />}
        data-testid="user-menu-button"
      >
        Olá, {userName ?? 'Usuário'}
      </ButtonDropdown>
      <DropdownMenu {...bindMenu(profileMenuState)}>
        <DropdownItemLink href="#" onClick={handleRecoverPasswordModal}>
          <DropdownItem>Alterar minha senha</DropdownItem>
        </DropdownItemLink>
        <DropdownItemLink onClick={async () => downloadFaq(await faqPdfLink)}>
          <DropdownItem>FAQ - Perguntas Frequentes</DropdownItem>
        </DropdownItemLink>
        <DropdownItemLink onClick={handleLogout}>
          <DropdownItem>Sair</DropdownItem>
        </DropdownItemLink>
      </DropdownMenu>
      <PasswordRecoverModal
        open={recoverPasswordModalOpen}
        onClose={handleRecoverPasswordModal}
      />
    </>
  );
};
export default UserMenu;
